import {
  COLOR_AI_GRADIENT_END,
  COLOR_AI_GRADIENT_MIDDLE,
  COLOR_AI_GRADIENT_START,
} from '../../../config/constants/colorCodes';

function getGradient(
  colorStart: string,
  colorMiddle: string,
  colorEnd: string,
): string {
  return `linear-gradient(to right, ${colorStart}, ${colorMiddle}, ${colorEnd})`;
}

export function getAIGradient(): string {
  return getGradient(
    COLOR_AI_GRADIENT_START,
    COLOR_AI_GRADIENT_MIDDLE,
    COLOR_AI_GRADIENT_END,
  );
}
